module.exports = __webpack_public_path__ + "img/battery_middle.209309d1.svg";